/* eslint-disable import/no-relative-packages */

import React from 'react';
import {
  View,
  Text,
  // Image,
  TouchableOpacity,
  Platform,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  Rating,
} from 'react-native-elements';
import PropTypes from 'prop-types';
import Publisher from '../../modules/data/Publisher';
import { language } from '../../localization';
import { translate } from '../../locales/i18n';
import styles from '../../styles';
import starStandard from '../../../node_modules/react-native-ratings/src/images/star.png'; // FIXME(clairbee): fix webpack config instead
import face from '../../assets/images/glyphicons-camera.png';
import PublisherIcon from './PublisherIcon';

import infraConfig from '../../config.json';

class PublisherBadge extends React.Component {
  static getImage(str) {
    // FIXME(clairbee): why 8 6 4 2, and not 2 2 2 2 ???
    const prefix = str.substring(6, 8)
      + str.substring(4, 6)
      + str.substring(2, 4)
      + str.substring(0, 2);
    // const prefix = data.uuid.substring(0, 8);
    // console.log(prefix);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);

    return { uri: `https://${infraConfig.userImagesThumbs128Bucket}.s3-${infraConfig.region}.amazonaws.com/${index}/${str}` };
  }

  render() {
    const {
      publisher, style, onPhotoPress, loadable,
    } = this.props;

    let image;
    if (Platform.OS === 'web') {
      image = { uri: face };
    } else {
      image = face;
    }
    let hasImage = false;

    if (publisher.data && publisher.data.image) {
      // console.log('Publisher icon image is found');
      image = PublisherBadge.getImage(publisher.data.image);
      hasImage = true;
    }
    // console.log('Publisher');
    // console.log(publisher);
    // console.log('Publisher icon image');
    // console.log(image);
    // console.log(publisher.data.image);

    const theIconItself = (
      <PublisherIcon
        style={{ width: 64, height: 64 }}
        loadingStyle={{ size: 'small', color: styles.primaryColor }}
        hasImage={hasImage}
        source={image}
        loadable={loadable}
      />
    );

    publisher.postProcess();

    const lang = publisher.lang || language();
    const desc = publisher.pp.desc[lang] || translate('profile_member_since', { year: publisher.data.year });

    return (
      <View
        style={[
          styles.publisherBadge.panel,
          style,
        ]}
      >
        {onPhotoPress !== undefined ? ( // eslint-disable-line no-nested-ternary
          Platform.OS !== 'web' ? (
            <TouchableOpacity
              onPress={onPhotoPress}
            >
              {theIconItself}
            </TouchableOpacity>
          ) : (
            <form>
              <input
                type="file"
                name="file"
                id="file"
                nesting="file" // eslint-disable-line
                // title={translate('endpoint_photo_upload')}
                onChange={onPhotoPress}
                style={{
                  display: 'none',
                  width: '0.1px',
                  height: '0.1px',
                  opacity: '0',
                  overflow: 'hidden',
                  position: 'absolute',
                  zIndex: '-1',
                }}
              />
              <label id="label" nesting="file" htmlFor="file"> {/* eslint-disable-line */}
                {theIconItself}
              </label>
            </form>
          )
        ) : (
          theIconItself
        )}
        <View style={styles.publisherBadge.panelInner}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Text style={styles.publisherBadge.name} numberOfLines={1} ellipsizeMode="tail">
              {publisher.data.name}
            </Text>
            {(publisher.data.reviews || 0) > 0 && (
              <View style={styles.publisherBadge.panelRating}>
                <Rating
                  type="custom"
                  ratingImage={starStandard}
                  ratingColor="#FE9065"
                  ratingCount={1}
                  imageSize={16}
                  readonly
                  startingValue={publisher.data.rating || 0}
                  style={styles.publisherBadge.rating}
                />
                <Text style={styles.publisherBadge.reviews}>{publisher.data.reviews}</Text>
              </View>
            )}
          </View>
          <Text style={styles.publisherBadge.description} numberOfLines={2} ellipsizeMode="tail">
            {desc || translate('profile_member_since', { year: publisher.data.year })}
          </Text>
          {/* <Rating style={styles.publisherBadge.rating} /> */}
        </View>
      </View>
    );
  }
}

PublisherBadge.defaultProps = {
  style: {},
  onPhotoPress: undefined,
  loadable: false,
};

PublisherBadge.propTypes = {
  publisher: PropTypes.instanceOf(Publisher).isRequired,
  style: ViewPropTypes.style,
  onPhotoPress: PropTypes.func,
  loadable: PropTypes.bool,
};

export default PublisherBadge;
